// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const FrogSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'frog-idle1',
    metadata: {
      frames: {
        'frog-idle1-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-idle1-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-idle1-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-idle1-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/frog/idle1.png',
        size: {
          w: 512,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'frog-idle1': [
          'frog-idle1-0',
          'frog-idle1-1',
          'frog-idle1-2',
          'frog-idle1-3',
        ],
      },
    },
  },
  {
    name: 'frog-idle2',
    metadata: {
      frames: {
        'frog-idle2-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-idle2-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-idle2-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-idle2-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-idle2-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/frog/idle2.png',
        size: {
          w: 640,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'frog-idle2': [
          'frog-idle2-0',
          'frog-idle2-1',
          'frog-idle2-2',
          'frog-idle2-3',
          'frog-idle2-4',
        ],
      },
    },
  },
  {
    name: 'frog-jump',
    metadata: {
      frames: {
        'frog-jump-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jump-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jump-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jump-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jump-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jump-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jump-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/frog/jump.png',
        size: {
          w: 896,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'frog-jump': [
          'frog-jump-0',
          'frog-jump-1',
          'frog-jump-2',
          'frog-jump-3',
          'frog-jump-4',
          'frog-jump-5',
          'frog-jump-6',
        ],
      },
    },
  },
  {
    name: 'frog-jumpIdle',
    metadata: {
      frames: {
        'frog-jumpIdle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpIdle-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/frog/jumpIdle.png',
        size: {
          w: 256,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'frog-jumpIdle': ['frog-jumpIdle-0', 'frog-jumpIdle-1'],
      },
    },
  },
  {
    name: 'frog-jumpLanding',
    metadata: {
      frames: {
        'frog-jumpLanding-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpLanding-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpLanding-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpLanding-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpLanding-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpLanding-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpLanding-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpLanding-7': {
          frame: {
            x: 896,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-jumpLanding-8': {
          frame: {
            x: 1024,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/frog/jumpLanding.png',
        size: {
          w: 1152,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'frog-jumpLanding': [
          'frog-jumpLanding-0',
          'frog-jumpLanding-1',
          'frog-jumpLanding-2',
          'frog-jumpLanding-3',
          'frog-jumpLanding-4',
          'frog-jumpLanding-5',
          'frog-jumpLanding-6',
          'frog-jumpLanding-7',
          'frog-jumpLanding-8',
        ],
      },
    },
  },
  {
    name: 'frog-attack1',
    metadata: {
      frames: {
        'frog-attack1-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-6': {
          frame: {
            x: 768,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-7': {
          frame: {
            x: 896,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-8': {
          frame: {
            x: 1024,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-9': {
          frame: {
            x: 1152,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-10': {
          frame: {
            x: 1280,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-11': {
          frame: {
            x: 1408,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-12': {
          frame: {
            x: 1536,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-13': {
          frame: {
            x: 1664,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-14': {
          frame: {
            x: 1792,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-attack1-15': {
          frame: {
            x: 1920,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/frog/attack1.png',
        size: {
          w: 2048,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'frog-attack1': [
          'frog-attack1-0',
          'frog-attack1-1',
          'frog-attack1-2',
          'frog-attack1-3',
          'frog-attack1-4',
          'frog-attack1-5',
          'frog-attack1-6',
          'frog-attack1-7',
          'frog-attack1-8',
          'frog-attack1-9',
          'frog-attack1-10',
          'frog-attack1-11',
          'frog-attack1-12',
          'frog-attack1-13',
          'frog-attack1-14',
          'frog-attack1-15',
        ],
      },
    },
  },
  {
    name: 'frog-hit',
    metadata: {
      frames: {
        'frog-hit-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-hit-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-hit-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-hit-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/frog/hit.png',
        size: {
          w: 512,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'frog-hit': ['frog-hit-0', 'frog-hit-1', 'frog-hit-2', 'frog-hit-3'],
      },
    },
  },
  {
    name: 'frog-dead',
    metadata: {
      frames: {
        'frog-dead-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-dead-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-dead-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-dead-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
        'frog-dead-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 64,
          },
          sourceSize: {
            w: 128,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/frog/dead.png',
        size: {
          w: 640,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'frog-dead': [
          'frog-dead-0',
          'frog-dead-1',
          'frog-dead-2',
          'frog-dead-3',
          'frog-dead-4',
        ],
      },
    },
  },
];
